import { Key, Entity } from '@briebug/ngrx-auto-entity';
import { UserRole } from './user-role.model';

export const compareDirectories = (
  a: DocumentDirectory,
  b: DocumentDirectory
) => {
  let deltaCmp = a.delta - b.delta;
  return deltaCmp != 0 ? deltaCmp : a.name.localeCompare(b.name);
};

@Entity({
  modelName: 'DocumentDirectory',
  comparer: compareDirectories,
})
export class DocumentDirectory {
  @Key id?: string;
  name: string;
  parent: string | null;
  delta: number;
}

@Entity({
  modelName: 'DocumentFile',
})
export class DocumentFile {
  @Key id?: string;
  title: string;
  fileName: string;
  fileExists?: boolean;
  parent: string;
  delta: number;
  document?: string;
  mimeType?: string;
  created?: string;
  access: number[];
  uploadUrl?: string;
}

export interface DocumentFileVM {
  id?: string;
  title: string;
  fileName: string;
  fileExists?: boolean;
  parent: string;
  delta: number;
  document?: string;
  mimeType?: string;
  created?: Date;
  access: UserRole[];
  uploadUrl?: string;
}

export interface DocumentDirectoryVM {
  id?: string;
  name: string;
  parent: string | null;
  delta: number;
  files: DocumentFileVM[];
  canDelete: boolean;
}

export interface DocumentDirectoryNode {
  directory: DocumentDirectory;
  children: DocumentDirectoryNode[];
}
